import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TxtInputComponent } from './templates/txt-input/txt-input.component';
import { DynamicFormBuilderComponent } from './dynamic-form-builder.component';
import { DynamicInputDirective } from './directives/dynamic-input.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './templates/dropdown/dropdown.component';
import { StaticHtmlComponent } from './templates/static-html/static-html.component';
import { CheckBoxComponent } from './templates/check-box/check-box.component';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';

@NgModule({
  declarations: [TxtInputComponent, DynamicFormBuilderComponent, DynamicInputDirective, DropdownComponent, StaticHtmlComponent, CheckBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    CheckboxModule
  ],
  exports: [DynamicFormBuilderComponent]
})
export class DynamicFormBuilderModule { }
